module.exports = __webpack_public_path__ + "img/programme4.2b99fd20.png";